export const IGetProfilesUseCaseType = Symbol('IGetProfilesUseCase');
